import { useMutation, useQueryClient } from '@tanstack/react-query'
import { OperadoresApi } from '@/services/api-routes'
import type { AtualizarOperadorPayload, CriarOperadorPayload } from '@/types/operador'
import { operadoresKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useCriarOperadorMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: CriarOperadorPayload) => OperadoresApi.criar(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: operadoresKeys.all })
      notifySuccess('Operador criado com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('criar o operador', error),
  })
}

export const useAtualizarOperadorMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: AtualizarOperadorPayload) => OperadoresApi.atualizar(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: operadoresKeys.all })
      notifySuccess('Operador atualizado com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('atualizar o operador', error),
  })
}

export const useAtualizarSituacaoOperadorMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ operadorId, ativar }: { operadorId: string; ativar: boolean }) =>
      ativar ? OperadoresApi.reativar(operadorId) : OperadoresApi.inativar(operadorId),
    onSuccess: (_data, { ativar }) => {
      void queryClient.invalidateQueries({ queryKey: operadoresKeys.all })
      notifySuccess(`Operador ${ativar ? 'reativado' : 'inativado'} com sucesso!`)
    },
    onError: (error) => notifyErrorFor('atualizar a situação do operador', error),
  })
}

export const useResetarSenhaOperadorMutation = () => {
  return useMutation({
    mutationFn: (operadorId: string) => OperadoresApi.resetarSenha(operadorId),
    onSuccess: () => {
      notifySuccess('Senha do operador redefinida para a senha padrão!')
    },
    onError: (error) => notifyErrorFor('redefinir a senha do operador', error),
  })
}
